export const Sport = {
  '16U': 510,
  '18U': 509,
  A: 14,
  'A+': 13,
  AA: 12,
  AAA: 11,
  AME: 6005,
  College: 22,
  'H.S.': 586,
  IND: 23,
  INT: 51,
  KOR: 32,
  Minors: 21,
  MLB: 1,
  NLB: 61,
  NPB: 31,
  OLY: 52,
  ROK: 16,
  WIN: 17,
  WPS: 576,
} as const;
export type Sport = (typeof Sport)[keyof typeof Sport];
